/**
 * {@see} https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
 */
export default function roundWithPrecision(number, precision) {
	const factor = Math.pow(10, precision);
	const tempNumber = number * factor;
	const roundedTempNumber = Math.round(tempNumber);
	return roundedTempNumber / factor;
}
